
import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import './Newprogram.css'; // Separate CSS file

import mechImg from '../img/aaaservices/VR.webp';
import mecadvance from '../img/aaaservices/virtual.webp';
import roboexpert from '../img/aaaservices/expertrobot.jpg';

import simImg from '../img/aaaservices/slashco-bridle1-2.jpg';
import tollbasic from '../img/aaaservices/toolbasic.jpg';
import tollexpert from '../img/aaaservices/tollexpert.jpg';


import itImg from '../img/aaaservices/Java-Full-Stack-1-600x367.jpg';
import advncejava from '../img/aaaservices/advncejava.jpg'; 
import javaexpert from '../img/aaaservices/javaexpert.png';
import digitaladvance from '../img/aaaservices/digitaladvance.jpg';
import digitalexpert from '../img/aaaservices/digitalexpert.avif';

import itImg1 from '../img/aaaservices/PY.jpg';
import advancepython from '../img/aaaservices/adancepython.jpg';
import pythonexpert from '../img/aaaservices/pynew.png';
import reactdev from '../img/aaaservices/reactada.jpg';
import fluuterdev from '../img/aaaservices/fluuterdata.jpg';
import springboot from '../img/aaaservices/javaspring.jpg';
import itImg2 from '../img/aaaservices/app-development-banner_33099-1720.avif';
import dfsImg from '../img/aaaservices/F.png';
import OnlyButtonrange from './OnlyButtonrange';

/* ---------------------------------------------------------
   Utility: convert a rupee amount into Indian-style words
   e.g. 59999 -> "Fifty Nine Thousand Nine Hundred Ninety Nine"
--------------------------------------------------------- */
const ONES = [
  "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
  "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
  "Seventeen", "Eighteen", "Nineteen"
];
const TENS = [
  "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
];

const twoDigitsToWords = (num) => {
  if (num < 20) return ONES[num];
  const tens = Math.floor(num / 10);
  const ones = num % 10;
  return `${TENS[tens]}${ones ? " " + ONES[ones] : ""}`;
};

const threeDigitsToWords = (num) => {
  const hundred = Math.floor(num / 100);
  const rest = num % 100;
  let str = "";
  if (hundred) str += `${ONES[hundred]} Hundred${rest ? " " : ""}`;
  if (rest) str += twoDigitsToWords(rest);
  return str.trim();
};

const numberToIndianWords = (num) => {
  if (!num || isNaN(num)) return "";
  num = Math.round(num);
  if (num === 0) return "Zero";

  const crore = Math.floor(num / 10000000);
  num %= 10000000;
  const lakh = Math.floor(num / 100000);
  num %= 100000;
  const thousand = Math.floor(num / 1000);
  num %= 1000;
  const hundred = num;

  let parts = [];
  if (crore) parts.push(`${threeDigitsToWords(crore)} Crore`);
  if (lakh) parts.push(`${threeDigitsToWords(lakh)} Lakh`);
  if (thousand) parts.push(`${threeDigitsToWords(thousand)} Thousand`);
  if (hundred) parts.push(threeDigitsToWords(hundred));

  return parts.join(" ").trim();
};

const priceInWords = (amount) => `${numberToIndianWords(amount)} Rupees Only`;

const cardData = {
  Mechanical: [
    {
      id: 1,
      title: "Virtual Robotics - Basic",
      subtitle: "Robotics Fundamentals & Automation",
      category: "Virtual Robotics",
      date: "2025-06-01",
      time: "10:00 AM - 4:00 PM",
      cost: "₹29,999",
      minPrice: 29999,
      maxPrice: 29999,
      duration: "2 Months",
       location: ["hyderabad", "jaipur"],
      language: "english",
      mode: "Offline",
      image: mechImg,
      link: "/Virtualpage",
      level: "basic"
    },
    {
      id: 2,
      title: "Virtual Robotics - Advanced",
      subtitle: "Industrial Robotics & Programming",
      category: "Virtual Robotics",
      date: "2025-06-05",
      time: "11:00 AM - 5:00 PM",
      cost: "₹49,999",
      minPrice: 49999,
      maxPrice: 49999,
      duration: "3 Months",
       location: ["hyderabad", "jaipur"],
      language: "english",
      mode: "Offline",
      image: mecadvance,
      link: "/Virtualpage",
      level: "advanced"
    },
    {
      id: 3,
      title: "Virtual Robotics - Expert",
      subtitle: "AI Robotics & Smart Factory Automation",
      category: "Virtual Robotics",
      date: "2025-06-10",
      time: "9:00 AM - 3:00 PM",
      cost: "₹69,999",
      minPrice: 69999,
      maxPrice: 69999,
      duration: "4Months",
      location: ["hyderabad", "jaipur"],
      language: "english",
      mode: "Offline",
      image: roboexpert,
      link: "/Virtualpage",
      level: "Expert"
    },
    {
      id: 4,
      title: "Tool & Fixture Design - Basic",
      subtitle: "Fundamentals of Tool Design",
      category: "Tool & Fixture Design",
      date: "2025-06-15",
      time: "10:00 AM - 4:00 PM",
      cost: "₹14,999",
      minPrice: 14999,
      maxPrice: 14999,
      duration: "2 Months",
      location: ["hyderabad", "jaipur"],
      language: "english",
      mode: "Offline",
      image: simImg,
      link: "/fixture",
      level: "basic"
    },
    {
      id: 5,
      title: "Tool & Fixture Design - Advanced",
      subtitle: "Industrial Tool & Fixture Development",
      category: "Tool & Fixture Design",
      date: "2025-06-20",
      time: "11:00 AM - 5:00 PM",
      cost: "₹29,999",
      minPrice: 29999,
      maxPrice: 29999,
      duration: "3 Months",
      location: ["hyderabad", "jaipur"],
      language: "english",
      mode: "Offline",
      image: tollbasic,
      link: "/fixture",
      level: "advanced"
    },
    {
      id: 6,
      title: "Tool & Fixture Design - Expert",
      subtitle: "Master Tooling & Manufacturing Solutions",
      category: "Tool & Fixture Design",
      date: "2025-06-25",
      time: "9:00 AM - 3:00 PM",
      cost: "₹59,999",
      minPrice: 59999,
      maxPrice: 59999,
      duration: "4Months",
       location: ["hyderabad", "jaipur"],
      language: "english",
      mode: "Offline",
      image: tollexpert,
      link: "/fixture",
      level: "Expert"
    },
    {
      id: 7,
      title: "Digital Factory - Basic",
      subtitle: "Smart Manufacturing Fundamentals",
      category: "Digital Factory",
      date: "2025-07-01",
      time: "10:00 AM - 4:00 PM",
      cost: "₹14,999",
      minPrice: 14999,
      maxPrice: 14999,
      duration: "2 Months",
       location: ["hyderabad", "jaipur"],
      language: "english",
      mode: "Offline",
      image: dfsImg,
      link: "/DigitalC",
      level: "basic"
    },
    {
      id: 8,
      title: "Digital Factory - Advanced",
      subtitle: "Industry 4.0 & Factory Simulation",
      category: "Digital Factory",
      date: "2025-07-05",
      time: "11:00 AM - 5:00 PM",
      cost: "₹29,999",
      minPrice: 29999,
      maxPrice: 29999,
      duration: "3 Months",
      location: ["hyderabad", "jaipur"],
      language: "english",
      mode: "Offline",
      image: digitaladvance,
      link: "/DigitalC",
      level: "advanced"
    },
    {
      id: 9,
      title: "Digital Factory - Expert",
      subtitle: "AI Powered Smart Factory & Automation",
      category: "Digital Factory",
      date: "2025-07-10",
      time: "9:00 AM - 3:00 PM",
      cost: "₹59,999",
      minPrice: 59999,
      maxPrice: 59999,
      duration: "4Months",
      location: ["hyderabad", "jaipur"],
      language: "english",
      mode: "Offline",
      image: digitalexpert,
      link: "/DigitalC",
      level: "Expert"
    }
  ],
  IT: [
  // Java Track
  {
    id: 10,
    title: "Java Programming",
    subtitle: "Core Java Basics",
    category: "Java",
    date: "2025-06-17",
    time: "1:00 PM - 6:00 PM",
    cost: "₹14,999",
    minPrice: 14999,
    maxPrice: 14999,
    duration: "2 Months",
    location: ["hyderabad", "jaipur"],
    language: "english",
    mode: "Online",
    image: itImg,
    link: "/it-services",
    level: "basic"
  },
  {
    id: 11,
    title: "Advanced Java Programming",
    subtitle: "Collections, JDBC & OOPs",
    category: "Java",
    date: "2025-06-19",
    time: "10:00 AM - 2:00 PM",
    cost: "₹29,999",
    minPrice: 29999,
    maxPrice: 29999,
    duration: "3 Months",
    location: ["hyderabad", "jaipur"],
    language: "english",
    mode: "Online",
    image: advncejava,
    link: "/it-services",
    level: "advanced"
  },
  {
    id: 12,
    title: "Java Full Stack",
    subtitle: "Complete Stack Developer",
    category: "Java",
    date: "2025-06-21",
    time: "9:00 AM - 5:00 PM",
    cost: "₹59,999",
    minPrice: 59999,
    maxPrice: 59999,
    duration: "4Months",
    location: ["hyderabad", "jaipur"],
    language: "english",
    mode: "Offline",
    image: javaexpert,
    link: "/it-services",
    level: "expert"
  },

  // Python Track
  {
    id: 13,
    title: "Python Programming",
    subtitle: "Python Fundamentals",
    category: "Python",
    date: "2025-06-22",
    time: "10:00 AM - 2:00 PM",
    cost: "₹14,999",
    minPrice: 14999,
    maxPrice: 14999,
    duration: "2 Months",
     location: ["hyderabad", "jaipur"],
    language: "english",
    mode: "Online",
    image: itImg1,
    link: "/Puthonpage",
    level: "basic"
  },
  {
    id: 14,
    title: "Advanced Python Programming",
    subtitle: "Django, APIs & Automation",
    category: "Python",
    date: "2025-06-24",
    time: "11:00 AM - 4:00 PM",
    cost: "₹29,999",
    minPrice: 29999,
    maxPrice: 29999,
    duration: "3 Months",
     location: ["hyderabad", "jaipur"],
    language: "english",
    mode: "Online",
    image: advancepython,
    link: "/Puthonpage",
    level: "advanced"
  },
  {
    id: 15,
    title: "Python Full Stack",
    subtitle: "Complete Stack Developer",
    category: "Python",
    date: "2025-06-26",
    time: "9:00 AM - 5:00 PM",
    cost: "₹59,999",
    minPrice: 59999,
    maxPrice: 59999,
    duration: "4Months",
     location: ["hyderabad", "jaipur"],
    language: "english",
    mode: "Offline",
    image: pythonexpert,
    link: "/Puthonpage",
    level: "expert"
  },

  // React Only
  {
    id: 16,
    title: "React Development",
    subtitle: "Frontend Framework",
    category: "React",
    date: "2025-06-28",
    time: "10:00 AM - 2:00 PM",
    cost: "₹14,999",
    minPrice: 14999,
    maxPrice: 14999,
    duration: "2 Months",
    location: ["hyderabad", "jaipur"],
    language: "english",
    mode: "Online",
    image: reactdev,
    link: "/Reactpage",
    level: "basic"
  },

  // Flutter Only
  {
    id: 17,
    title: "Flutter Development",
    subtitle: "Cross-Platform Apps",
    category: "Flutter",
    date: "2025-06-29",
    time: "10:00 AM - 2:00 PM",
    cost: "₹14,999",
    minPrice: 14999,
    maxPrice: 14999,
    duration: "2 Months",
    location: ["hyderabad", "jaipur"],
    language: "english",
    mode: "Online",
    image: fluuterdev,
    link: "/Flutterpage",
    level: "basic"
  },

  // Spring Boot & MySQL
  {
    id: 18,
    title: "Spring Boot & MySQL",
    subtitle: "Backend Development",
    category: "Spring Boot",
    date: "2025-06-30",
    time: "11:00 AM - 4:00 PM",
    cost: "₹29,999",
    minPrice: 29999,
    maxPrice: 29999,
    duration: "3 Months",
    location: ["hyderabad", "jaipur"],
    language: "english",
    mode: "Offline",
    image: springboot,
    link: "/Springbootpage",
    level: "advanced"
  },

  // HTML CSS JavaScript
  {
    id: 19,
    title: "HTML, CSS & JavaScript",
    subtitle: "Complete Web Fundamentals",
    category: "Web Fundamentals",
    date: "2025-07-01",
    time: "10:00 AM - 3:00 PM",
    cost: "₹14,999",
    minPrice: 14999,
    maxPrice: 14999,
    duration: "2 Months",
   location: ["hyderabad", "jaipur"],
    language: "english",
    mode: "Online",
    image: itImg2,
    link: "/Htmlpage",
    level: "basic"
  }
]
};

const BranchFilterComponent = () => {
  const navigate = useNavigate();

  const [selectedBranch, setSelectedBranch] = useState("All");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [location, setLocation] = useState("");
  const [language, setLanguage] = useState("");
  const [selectedMode, setSelectedMode] = useState("All");
  const [selectedLevel, setSelectedLevel] = useState("All");

  // Branch change hone par category reset karo
  const handleBranchChange = (value) => {
    setSelectedBranch(value);
    setSelectedCategory("All");
  };

  // Selected branch ke hisaab se available categories nikalo
  const getAvailableCategories = () => {
    const source =
      selectedBranch === "All"
        ? [...cardData.Mechanical, ...cardData.IT]
        : cardData[selectedBranch] || [];

    return [...new Set(source.map((card) => card.category))];
  };

  const getFilteredData = () => {
  let mechanical = cardData.Mechanical;
  let it = cardData.IT;

  // Location ke according courses filter
  if (location) {
    mechanical = mechanical.filter((card) =>
      Array.isArray(card.location)
        ? card.location.includes(location)
        : card.location === location
    );

    it = it.filter((card) =>
      Array.isArray(card.location)
        ? card.location.includes(location)
        : card.location === location
    );
  }

  // Category filter
  if (selectedCategory !== "All") {
    mechanical = mechanical.filter(
      (card) => card.category === selectedCategory
    );

    it = it.filter(
      (card) => card.category === selectedCategory
    );
  }

  // Location ke according order
  let data;

  if (location === "jaipur") {
    data = [...it, ...mechanical];
  } else if (location === "hyderabad") {
    data = [...mechanical, ...it];
  } else {
    data = [...mechanical, ...it];
  }

  // Mode
  if (selectedMode !== "All") {
    data = data.filter((card) => card.mode === selectedMode);
  }

  // Level
  if (selectedLevel !== "All") {
    data = data.filter((card) => card.level === selectedLevel);
  }

  return data;
};

  return (
    <div className="course-container">
      {/* Fixed Sidebar */}
      <div className="course-sidebar">
        <h3 className="course-sidebar-title">Filters</h3>

        <label className="course-select-label">Branch</label>
        <select
          className="course-select"
          value={selectedBranch}
          onChange={(e) => handleBranchChange(e.target.value)}
        >
          <option value="All">All Branches</option>
          <option value="Mechanical">Mechanical</option>
          <option value="IT">IT</option>
        </select>

        <label className="course-select-label">Category</label>
        <select
          className="course-select"
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
        >
          <option value="All">All Categories</option>
          {getAvailableCategories().map((cat) => (
            <option key={cat} value={cat}>
              {cat}
            </option>
          ))}
        </select>

        <label className="course-select-label">Course Type</label>
        <select
          className="course-select"
          value={selectedMode}
          onChange={(e) => setSelectedMode(e.target.value)}
        >
          <option value="All">Online &amp; Offline</option>
          <option value="Online">Online Courses</option>
          <option value="Offline">Offline Courses</option>
        </select>

        <label className="course-select-label">Level</label>
        <select
          className="course-select"
          value={selectedLevel}
          onChange={(e) => setSelectedLevel(e.target.value)}
        >
          <option value="All">All Levels</option>
          <option value="basic">Basic (2 Months)</option>
          <option value="advanced">Advanced (3 Months)</option>
          <option value="Expert">Expert (4 Months)</option>
        </select>

        <label className="course-select-label">Location</label>
        <select className="course-select" value={location} onChange={(e) => setLocation(e.target.value)}>
          <option value="">All Locations</option>
          <option value="hyderabad">Hyderabad</option>
           <option value="jaipur">Jaipur</option>
        </select>
        

        {/* <label className="course-select-label">Language</label>
        <select className="course-select" value={language} onChange={(e) => setLanguage(e.target.value)}>
          <option value="">All Languages</option>
          <option value="english">English</option>
        </select> */}
      </div>

      {/* Cards Section - 4 Cards per row */}
      <div className="course-main-content">
        <div className="course-grid">
          {getFilteredData().map((card) => (
            <div
              className="course-card"
              key={card.id}
              onClick={() => navigate(card.link)}
            >
              <div className="course-card-image-wrap">
                <img className="course-card-image" src={card.image} alt={card.title} />
                <span className={`course-card-mode-badge ${card.mode === "Online" ? "is-online" : "is-offline"}`}>
                  {card.mode}
                </span>
                <span className="course-card-level-badge">{card.level}</span>
              </div>
              <div className="course-card-content">
                <p className="course-card-title">{card.title}</p>
                <p className="course-card-subtitle">{card.subtitle}</p>

                <div className="course-card-meta">
                  <span className="course-card-duration">{card.duration}</span>
                  <span className="course-card-language">{card.language}</span>
                </div>

                <div className="course-card-price-block">
                  <p className="course-card-price">{card.cost}</p>
                  <p className="course-card-price-words">{priceInWords(card.minPrice)}</p>
                </div>

                <button className="course-card-button">Know More</button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* <div className="course-button-range">
        <OnlyButtonrange />
      </div> */}
    </div>
  );
};

export default BranchFilterComponent;